import { getPreferredLanguage } from './index';

/**
 * The language of the loneliness programme's screens and content (measure,
 * Program tab, registration, welcome email). English is the default;
 * Norwegian bokmål when the browser (or the saved app language) is
 * Norwegian (Markus, 2026-11-05: English first, Norwegian as the option).
 * Sent to the API as `lang`, which words the questions, the weeks, the
 * guide and the email the same way.
 */
export type ContentLanguage = 'en' | 'nb';

export const contentLanguage = (): ContentLanguage =>
  getPreferredLanguage('en') === 'no' ? 'nb' : 'en';

/** The English text, or the Norwegian one when the browser is Norwegian. */
export const pick = <T>(en: T, nb: T): T =>
  contentLanguage() === 'nb' ? nb : en;

/** The query the content routes take. */
export const langParams = (): { lang: ContentLanguage } => ({
  lang: contentLanguage(),
});
